/**
 * Implementation of a terminal interface.  It defines the methods which should be
 * overridden to implement a terminal that may interacted with in a uniform way.
 */
export default class ITerminal {
  /**
   * Must be overridden by a concrete class to process a payment of the amount specified.
   * The implementation must return a jQuery promise that resolves and rejectswith a
   * TerminalTransactionResponse.  The promise only resolves for APPROVED or APPROVED_WITH_ERRORS
   * responses and must be rejected for all other types of responses.
   *
   * @param {Object} paymentOptions  Options to process the payment.  All terminals must support as a minimum:
   * @param {Decimal} paymentOptions.amount The amount to transact with the terminal.
   * @param {Number} paymentOptions.saleID   The ID of the sale to which the transaction will be associated
   * @param {GatewayConfig} paymentOptions.gatewayConfig The gateway configuration used to transact the request
   */
  processPayment(paymentOptions) {}

  /**
   * Must be overridden by a concrete class to cancel an in progress operation.  Must return
   * a jQuery promise that resolves once the transaction has been successfully cancelled.
   */
  cancelTransaction() {}

  /**
   * Must be overridden by a concrete class to void a transaction.  Must return a jQuery
   * promise that resolves once the transaction has been successfully voided.
   *
   * @param payment {Payment} The payment that must be voided
   */
  voidTransaction(payment) {}

  /**
   * Must be overridden by a concrete class to check the status of the terminal.  The status
   * returned must be of the TerminalEventGenerator.TerminalStatus type.
   */
  checkStatus() {}

  /**
   * Must be overridden by a concrete class to retrieve a description of the terminal type.  Must
   * return a string.
   */
  description() {}

  /**
   * Must be overridden by a concrete class to return data about the terminal which is custom
   * for each type of terminal.  Must return an object of key value pairs.
   */
  info() {}
}
